import Vue from "vue";
import App from "./App.vue";
import "./assets/reset.css";

import axios from "axios";
Vue.prototype.axios = axios;

import router from "./router";
import gcComponent from "./components/global";

// подключаем кастомные глобальные компоненты
// import * as gcComponents from "./components/global";
// console.log(gcComponents);
// Object.values(gcComponents).forEach(gcComponent => {
//     Vue.use(gcComponent);
// });

// Vue.prototype.gcComponents = gcComponents;
// const install = (Vue, options = {}) => {
//     // Use Components
//     console.log(options);
//     Object.values(gcComponents).forEach(gcComponent => {
//         Vue.use(gcComponent);
//     });
// };

// if (typeof window !== "undefined" && window.Vue) {
//     install(window.Vue);
// }

// export default install;

export { default as gcPopup } from "./components/global/gcPopup";
// Vue.prototype.gcComponents = gcComponents;
Vue.use(gcComponent);
Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");
